{{#if asModalDialog}}
<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{TR "Heizkreis umbenennen"}}</h4>
</div>
<div class="modal-body">
{{/if}}
	{{#if errors.error}}
		<div class="alert alert-danger">
			{{TR errors.error}}
			{{#if errors.sysErr}}
			 ({{ERROR_TR errors.sysErr}})
			{{/if}}
		</div>
	{{/if}}
	<div class="row">
		<div class="col-xs-12">
			<div class="form-group">
				<label for="name" class="control-label">{{TR "Name"}} {{TR formData.defaultName}}</label>
				<input type="text" class="form-control {{#if errors.name}}parsley-error{{/if}}" id="name-input" name="name" placeholder="{{TR "Name"}}" value="{{formData.name}}" size="25">
				{{#if errors.name}}
				<ul class="parsley-errors-list filled" id="js-name-error">
				<li class="parsley-required">{{TR errors.name}}</li>
				</ul>
				{{/if}}
			</div>
		</div>
	</div>
{{#if asModalDialog}}
</div>
<div class="modal-footer">
	<button id="ct-cancel" type="button" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<button class="btn btn-primary" id="js-success">{{TR "Speichern"}}</button>
</div>
{{/if}}
